import styled from 'styled-components';
const percentageSize = 1.3;

export const InformacioPuntContainer = styled.div`
  width: 100vw;
  height: ${(props) => props.altura};
  max-height: 100%;
  background-color: #333c;
  z-index: 7;
  margin: 0;
  position: fixed;
  bottom: 0;
  /* display: ${({ open }) => (open ? 'block' : 'none')}; */
`;

export const InformacioPuntWrapper = styled.div`
  height: ${(props) => props.altura};
  /* display: grid;
  grid-template-rows: ${(props) => (props.displayInfoPuntBody ? '25px 0.5fr 30px' : '25px')}; */

  @media screen and (max-width: 464px) {
    /* grid-template-rows: ${(props) => (props.displayInfoPuntBody ? '25px 1fr' : '25px')}; */
  }
`;

export const InformacioPuntBar = styled.nav`
  background-color: #333;
  /* box-shadow: 0 4px 7px -2px #252525; */
  /* display: grid;
  grid-template-rows: 1fr 1fr; */
  padding-left: 1em;
  padding-right: 1em;
  user-select: none;
  z-index: 3;
`;

export const InformacioPuntBarUpperRow = styled.div`
  display: flex;
  justify-content: center;
  height: 6px;
  align-items: center;
`;

export const InformacioPuntBarLowerRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const BarTitleWrappper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  /* height: 15px; */
  padding-bottom: 6px;
`;

export const BarDragIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: n-resize;
  align-items: flex-start;
  padding-top: 3px;
`;

export const BarSizeBtnsWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  flex-direction: row;
  height: 19px;
  @media screen and (max-width: 468) {
    height: 100%;
    padding-bottom: 5px;
  }
`;

export const CloseBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
`;

export const MaximizeBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  transform: rotate(180deg) scale(0.8);
  margin-left: 5px;
  margin-right: 5px;
`;

export const MinimizeBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  transform: scale(0.8);
  margin-left: 5px;
  margin-right: 5px;
`;

export const FullMinimizeBtnWrapper = styled.div`
  color: white;
`;

export const BarBtn = styled.button`
  background-color: transparent;
  border: 0px;
  margin: 0px;
  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BarTitle = styled.span`
  color: white;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 15 * percentageSize : 15)}px;

  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 13 * percentageSize : 13)}px;
  }
`;

export const BarDragIcon = styled.div`
  height: 0.3em;
  width: 5em;
  border-radius: 0.5em;
  background-color: #ccc;
  display: inline-flex;
`;

export const ButtonIcon = styled.img`
  vertical-align: middle;
  text-align: center;
  margin: auto;
  display: flex;
  transform: scale(0.8);
  filter: brightness(0) invert(1);
`;

export const InfoPuntSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const MinSVG = styled.svg.attrs((props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  version: '1.1',
  x: '0px',
  y: '0px',
  fill: 'white',
  viewBox: '0 0 64 64',
  width: props.fontSizeEnabled ? 24 * percentageSize : 24,
  height: props.fontSizeEnabled ? 24 * percentageSize : 24
}))``;

export const TabContainer = styled.div`
  height: 24px;
  width: 200px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
  cursor: ${({ enabled }) => (enabled ? 'pointer' : 'default')};
  opacity: ${({ enabled }) => (enabled ? '100%' : '40%')};
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 14 * percentageSize : 14)}px;
  padding: 0px 5px;
  background-color: #666666;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 930px) {
    width: ${({ long }) => (long ? '190px' : '120px')};
  }
  @media screen and (max-width: 750px) {
    width: 60px;
  }
`;

export const TabInfo = styled.div`
  display: flex;
  align-items: center;
  color: ${({ selected }) => (selected ? '#febf00' : 'white')};
`;
export const TabClose = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
`;
export const TabIcon = styled.div`
  margin-right: 10px;
  display: flex;
`;
export const TabTitle = styled.div``;
